import createIcon from '../../createIcon';

/**
 * @component @name NoMeals
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNzA0NSAxMy4zNDU3VjUuMzQ1N0MxNi43MDQ1IDMuNTg1NyAxOC45NDQ1IDEuMzQ1NyAyMS43MDQ1IDEuMzQ1N1YxNy41MTU3TDE5LjcwNDUgMTUuNTE1N1YxMy4zNDU3SDE2LjcwNDVaTTIxLjE5NDUgMjIuNjU1N0wxMC43MjQ1IDEyLjE5NTdDMTAuMzk0NSAxMi4yODU3IDEwLjA2NDUgMTIuMzQ1NyA5LjcwNDUzIDEyLjM0NTdWMjEuMzQ1N0g3LjcwNDUzVjEyLjM0NTdDNS40OTQ1MyAxMi4zNDU3IDMuNzA0NTMgMTAuNTU1NyAzLjcwNDUzIDguMzQ1N1Y1LjE3NTdMMS4zOTQ1MyAyLjg1NTdMMi44MDQ1MyAxLjQ0NTdMMjIuNjA0NSAyMS4yNDU3TDIxLjE5NDUgMjIuNjU1N1pNNi44NzQ1MyA4LjM0NTdMNS43MDQ1MyA3LjE3NTdWOC4zNDU3SDYuODc0NTNaTTkuNzA0NTMgMS4zNDU3SDcuNzA0NTNWMy41MTU3TDkuNzA0NTMgNS41MTU3VjEuMzQ1N1pNMTMuNzA0NSA4LjM0NTdWMS4zNDU3SDExLjcwNDVWNy41MTU3TDEzLjU1NDUgOS4zNjU3QzEzLjY0NDUgOS4wMzU3IDEzLjcwNDUgOC43MDU3IDEzLjcwNDUgOC4zNDU3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoMeals = createIcon('NoMeals', [
  [
    'path',
    {
      d: 'M16.7045 13.3457V5.3457C16.7045 3.5857 18.9445 1.3457 21.7045 1.3457V17.5157L19.7045 15.5157V13.3457H16.7045ZM21.1945 22.6557L10.7245 12.1957C10.3945 12.2857 10.0645 12.3457 9.70453 12.3457V21.3457H7.70453V12.3457C5.49453 12.3457 3.70453 10.5557 3.70453 8.3457V5.1757L1.39453 2.8557L2.80453 1.4457L22.6045 21.2457L21.1945 22.6557ZM6.87453 8.3457L5.70453 7.1757V8.3457H6.87453ZM9.70453 1.3457H7.70453V3.5157L9.70453 5.5157V1.3457ZM13.7045 8.3457V1.3457H11.7045V7.5157L13.5545 9.3657C13.6445 9.0357 13.7045 8.7057 13.7045 8.3457Z',
      key: '50wutc',
    },
  ],
]);

export default NoMeals;
